// extracted by mini-css-extract-plugin
export default {"gallery":"wPvzQ","galleryItem":"qelxI","productItem":"Aev_E","wrapper":"Hb5uE","productItemUzb":"fOk1Q"};